export default "__VITE_ASSET__da32e2d7__"